import React from 'react';
import './Links.css';
import { FaLink } from 'react-icons/fa';

function Links() {
  const linksLeft = [
    {
      title: 'Admissions Checklist for International Freshmen',
      url: 'https://www.southeastern.edu/admin/international/assets/bfchecklist.pdf'
    },
    {
      title: "Information Required for Louisiana Driver's License Application",
      url: 'https://www.southeastern.edu/admin/international/current_students/practical_matters/id/index.html'
    },
    {
      title: 'On-Campus Employment Guidelines for International Students',
      url: 'https://www.southeastern.edu/admin/international/current_students/employment/index.html'
    },
    {
      title: 'Applying for OPT After Graduation',
      url: 'https://www.southeastern.edu/admin/international/current_students/employment/opt/index.html'
    }
  ];

  const linksRight = [
    {
      title: 'Applying for an SSN as an International Student',
      url: 'https://www.southeastern.edu/admin/international/current_students/legal_matters/ssn/index.html'
    },
    {
      title: 'Important Travel Information (USA & International)',
      url: 'https://www.southeastern.edu/admin/international/current_students/travel/index.html'
    },
    {
      title: 'Completing CPT Process After Internship',
      url: 'https://www.southeastern.edu/admin/international/current_students/employment/cpt/index.html'
    },
    {
      title: 'Insurance Information for International Students',
      url: 'https://www.southeastern.edu/admin/international/current_students/practical_matters/health/index.html'
    },
    {
      title: 'Useful Forms for Current & Incoming Students',
      url: 'https://www.southeastern.edu/admin/international/forms/index.html'
    }
  ];

  return (
    <div className="links-page">
      <h1 className="links-heading">🌐 Resources for NSAS Students</h1>

      <div className="links-grid">
        {[...linksLeft, ...linksRight].map((item, index) => (
          <a key={index} href={item.url} className="link-card" target="_blank" rel="noreferrer">
            <FaLink className="link-icon" />
            <div className="link-text">
              <h4>{item.title}</h4>
            </div>
          </a>
        ))}
      </div>

      <div className="support-section">
        <h2>🧾 International Support Services</h2>
        <p>
          Need help with laundry, food pantry, or meal plans? Visit the{' '}
          <a
            href="https://www.southeastern.edu/admin/misa/international/index.html"
            target="_blank"
            rel="noreferrer">
            International Support Services
          </a>{' '}
          page to learn more about Southeastern’s student resources.
        </p>
      </div>
    </div>
  );
}

export default Links;
